import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faInfo, faCode, faListCheck, faGlobe } from '@fortawesome/free-solid-svg-icons';
import { faReact, faJsSquare, faCss3Alt } from '@fortawesome/free-brands-svg-icons';

interface InfoModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const InfoModal: React.FC<InfoModalProps> = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content info-modal">
        <div className="modal-header">
          <h2 className="modal-title"><FontAwesomeIcon icon={faInfo} className="modal-icon" /> Informações do Sistema</h2>
          <button onClick={onClose} className="modal-close-btn" title="Fechar Informações">
            <FontAwesomeIcon icon={faTimes} />
          </button>
        </div>
        <div className="modal-body info-content">
          <div className="info-section">
            <h3><FontAwesomeIcon icon={faListCheck} /> Sobre o Sistema</h3>
            <p>O <strong>Checklist Espanha</strong> é um sistema de gerenciamento de documentos para processos de cidadania espanhola. Ele foi desenvolvido para otimizar a organização e a geração de checklists personalizados, facilitando o trabalho dos usuários.</p>
            <p>As principais funcionalidades incluem a busca de clientes, a seleção de tipos de processo e a exportação de documentos em formato Word.</p>
          </div>

          <div className="info-section">
            <h3><FontAwesomeIcon icon={faCode} /> Tecnologias Utilizadas</h3>
            <div className="tech-grid">
              <div className="tech-item">
                <h4><FontAwesomeIcon icon={faReact} /> React</h4>
                <p>Biblioteca JavaScript para construção da interface do usuário.</p>
              </div>
              <div className="tech-item">
                <h4><FontAwesomeIcon icon={faJsSquare} /> TypeScript</h4>
                <p>Superset do JavaScript que adiciona tipagem estática para maior robustez.</p>
              </div>
              <div className="tech-item">
                <h4>Vite</h4>
                <p>Ferramenta de build de frontend de próxima geração para desenvolvimento rápido.</p>
              </div>
              <div className="tech-item">
                <h4><FontAwesomeIcon icon={faCss3Alt} /> CSS Moderno</h4>
                <p>Estilização responsiva e moderna para uma experiência de usuário agradável.</p>
              </div>
              <div className="tech-item">
                <h4>Supabase</h4>
                <p>Backend-as-a-Service (BaaS) para banco de dados PostgreSQL e autenticação.</p>
              </div>
              <div className="tech-item">
                <h4>Font Awesome</h4>
                <p>Biblioteca de ícones para elementos visuais.</p>
              </div>
            </div>
          </div>

          <div className="info-section">
            <h3><FontAwesomeIcon icon={faGlobe} /> Informações Técnicas</h3>
            <div className="tech-details">
              <div className="detail-item">
                <strong>Versão:</strong> 2.0.0
              </div>
              <div className="detail-item">
                <strong>Última Atualização:</strong> Setembro 2025
              </div>
            </div>
          </div>

          <div className="info-section">
            <h3>📋 Funcionalidades Principais</h3>
            <ul>
              <li>✅ Busca de clientes por email</li>
              <li>✅ Geração de checklists personalizados</li>
              <li>✅ Exportação de documentos Word (.docx)</li>
              <li>✅ Sistema de autenticação com roles (Master, Admin, User)</li>
              <li>✅ Gestão de usuários (apenas para administradores)</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};
